import CommandHandler from 'diagram-js/lib/command/CommandHandler';
import {ModelingUtil} from '@ispm/shared/bpmn-io/modeling-util';
import {PathwaysModeling} from '@ispm-client/modules/bpmn-modeler/bpmn/commands/pathways-modeling';
import EventBus from 'diagram-js/lib/core/EventBus';
import {EventType} from '@ispm/shared/bpmn-io/bpmn-js';
import {NodeType} from '@ispm/shared/bpmn-io/node-type';
import * as _ from 'lodash';
import {isEmpty} from 'lodash';
import {FloatingNodesService} from "@ispm/shared/bpmn-io/services/floating-nodes-service";
import {connection, END_NODE_ID} from '@ispm-shared/modules/bpmn/diagram-element-terms';
import {select, Store} from "@ngrx/store";
import {selectFloatedNodesByLayer} from "@ispm-client/modules/bpmn-modeler/store/selectors/floating-nodes.selector";
import {take} from "rxjs/operators";
import {State} from "@ispm-client/modules/bpmn-modeler/store/state";

export class RemoveNodeHandler implements CommandHandler {


  constructor(protected pathwaysModeling: PathwaysModeling, protected eventBus: EventBus, protected floatingNodesService: FloatingNodesService,protected store$: Store<State>, protected elementRegistry) {
  }

  preExecute(context) {
    const element = context.element;
    let elementsToRemove = [element];
    const nodeDetails = ModelingUtil.getNodeDetails(element);
    // check if node has sibling (brother or sister) -> there are loops
    const hasSibling = ModelingUtil.hasTargetConnectedSiblingNodes(element);
    const incoming = element.incoming;
    const outgoing = element.outgoing;
    // test type of this element
    context.elementsToRemove = elementsToRemove;
    if (nodeDetails !== undefined) {
      if (nodeDetails.nodeType === NodeType.normal || nodeDetails.nodeType === NodeType.neighborhood_entry) {
        // if its the last child of a sub process remove the gateway

        if (incoming.length > 0) {

          const incomingConnections = incoming[0];
          const incomingGateway = incomingConnections.source;

          if (incomingGateway.outgoing.length === 1) {
            // delete gateway and its incoming connections
            elementsToRemove = [...elementsToRemove, ...incomingGateway.incoming, incomingGateway];
            // delete floated outgoing gateway.
            elementsToRemove = this.deleteOutgoingFloatedGateway(element, elementsToRemove);
          } else {
            // delete element and outgoing gateway without deleting the incoming nodes
            if (outgoing.length > 0) {
              const outgoingConnection = element.outgoing[0];
              // if the outgoing element is treatment / neighborhood head - there is no gateway and TP node remain floating

              let outgoingGateway = ModelingUtil.getNodeType(outgoingConnection.target) === NodeType.treatment || ModelingUtil.getNodeType(outgoingConnection.target) === NodeType.neighborhood_head ? undefined : outgoingConnection.target;
              outgoingGateway = outgoingGateway && ModelingUtil.getNodeIncomingConnections(outgoingGateway, true).length > 1 ? undefined : outgoingGateway;
              if (outgoingGateway) {
                elementsToRemove = [...elementsToRemove, incomingConnections, outgoingConnection, outgoingGateway];
              } else {
                elementsToRemove = [...elementsToRemove, incomingConnections, outgoingConnection];
              }
            }
          }
        } else {
          // incoming = 0 delete floated outgoing gateway if its existed.
          elementsToRemove = this.deleteOutgoingFloatedGateway(element, elementsToRemove);
        }
      }
      if (nodeDetails.nodeType === NodeType.treatment) {
        // Need to remove the connection otherwise it will connect the parent with the end node
        const parents = element.incoming;
        parents.forEach(function (parent) {
          if (parent.type === connection) {
            elementsToRemove.push(parent);
          }
        });
      }
      if (nodeDetails.nodeType === NodeType.neighborhood_entry) {
        if (!hasSibling && outgoing && outgoing.length > 0) {
          const neighborhoodHead = outgoing[0].target;
          const neighborhoodHeadOutgoingConnection = neighborhoodHead.outgoing;
          if (neighborhoodHeadOutgoingConnection && neighborhoodHeadOutgoingConnection.length > 0) {
            const outgoingNode = neighborhoodHeadOutgoingConnection[0].target;
            if (outgoingNode) {
              if (ModelingUtil.isGateway(outgoingNode)) {
                let childrenNodes = ModelingUtil.getTreeChildren(neighborhoodHead);
                childrenNodes = childrenNodes ? childrenNodes.filter(child => child.id !== END_NODE_ID) : childrenNodes;
                elementsToRemove = [...elementsToRemove, neighborhoodHead, outgoingNode, ...childrenNodes];
              } else {
                elementsToRemove = [...elementsToRemove, neighborhoodHead, outgoingNode];
              }
            }
          } else {
            elementsToRemove = [...elementsToRemove, neighborhoodHead];
          }
          this.store$.pipe(select(selectFloatedNodesByLayer(neighborhoodHead.id)), take(1)).subscribe(floatedNodeIDs => {
            if (!_.isEmpty(floatedNodeIDs)) {
              floatedNodeIDs.forEach((floatedNodeId) => {
                const floatedNodeElement = this.elementRegistry.get(floatedNodeId);
                if (floatedNodeElement) {
                  elementsToRemove = [...elementsToRemove, floatedNodeElement];
                }
              });
            }
          });
        }
      }
      context.elementsToRemove = elementsToRemove;
    }
    if (!isEmpty(elementsToRemove) && !context.onSubmitForApproval && !context.onRemoveFloatedElements) {
      this.floatingNodesService.addFloatedElementWhenRemovingNodes(context.element);
    }
  }

  postExecute(context): any {
    const elementsToRemove = context.elementsToRemove;
    if (ModelingUtil.isGateway(context.element)) {
      this.pathwaysModeling.removeElements([context.element]);
    } else {
      if (!isEmpty(elementsToRemove)) {
        if (!ModelingUtil.hasDeletionTrackingChange(context.element)) {
          this.floatingNodesService.removeFloatedElementsFromRegistryInNeighborhood(elementsToRemove)
        }
        if (context.onSubmitForApproval !== true) {
          const targets = ModelingUtil.getDirectTreeChildrenNodes(context.element);
          this.pathwaysModeling.removeElements(elementsToRemove);
          this.eventBus.fire(EventType.NODE_UPDATED, {targets});
        }
        this.eventBus.fire(EventType.NODE_REMOVED, {elements: elementsToRemove});
      }
    }
  }

  protected updateDirectTreeAfterRemovingNode(nodeToRemove) {
    const targets = ModelingUtil.getDirectTreeChildrenNodes(nodeToRemove);
    this.eventBus.fire(EventType.NODE_UPDATED, {targets});
  }

  private deleteOutgoingFloatedGateway(element, elementsToRemove) {
    const outgoingConnection = element.outgoing[0];
    const outgoingGateway = outgoingConnection && ModelingUtil.isGateway(outgoingConnection.target) ? outgoingConnection.target : undefined;
    if (outgoingGateway && outgoingGateway.outgoing.length === 0) {
      elementsToRemove = [...elementsToRemove, ...outgoingGateway.incoming, outgoingGateway];
    }
    return elementsToRemove;
  }

}
